import { useMutationCommon } from "hooks/useCRUD";
import InvoiceStatementService from "services/InvoiceStatementService";

// Tìm hóa đơn để lập bảng kê. Dùng mutation vì người dùng chủ động bấm tìm,
// không cần cache theo queryKey và không được tự refetch.
export const usePrepareStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.prepareStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "prepareStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Tạo bảng kê từ danh sách hóa đơn đã tích chọn
export const useInitStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.initStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "initStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Lấy chi tiết bảng kê. Dùng mutation vì chỉ gọi khi đã có statement_id
// từ bước tạo, không cần cache theo queryKey.
export const useStatementDetail = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.getStatementDetail,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "getStatementDetail",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Hỏi trạng thái file PDF của bảng kê
export const useStatementPdfStatus = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.getStatementPdfStatus,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "getStatementPdf",
    target: "statement",
    isNotifyError: false,
    isNotifySuccess: false,
  });

  return mutation;
};

// Tải file PDF bảng kê
export const useDownloadStatementPdf = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.downloadStatementPdf,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "downloadStatement",
    target: "statement",
    isNotifyError: false,
    isNotifySuccess: false,
  });

  return mutation;
};

// Lưu bảng kê sau khi điều chỉnh
export const useSaveStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.saveStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "saveStatement",
    target: "statement",
    isNotifyError: true,
    // HTTP 200 kèm result=false vẫn chạy vào nhánh success của useCRUD, nên
    // không bật toast mặc định; phía gọi tự kiểm result rồi mới báo.
    isNotifySuccess: false,
  });

  return mutation;
};

// Xem PDF một hóa đơn trong danh sách chọn. Response dạng { result, file }
// với file là base64, phía gọi tự đổi sang blob.
export const useReviewInvoicePdf = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.reviewInvoicePdf,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "reviewInvoicePdf",
    target: "statement",
    isNotifyError: false,
    isNotifySuccess: false,
  });

  return mutation;
};

// Ký số bảng kê. Không bật toast thành công mặc định: HTTP 200 kèm
// result=false vẫn bị useCRUD coi là thành công, phía gọi tự kiểm rồi báo.
export const useSignStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.signStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "signStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Gửi bảng kê cho kế toán duyệt
export const useSubmitStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.submitStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "submitStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Kế toán duyệt bảng kê
export const useApproveStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.approveStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "approveStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Hủy bảng kê còn lưu tạm
export const useCancelStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.cancelStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "cancelStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Kế toán từ chối duyệt bảng kê
export const useRejectStatement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: InvoiceStatementService.rejectStatement,
    onSuccess,
    onError,
    translation: ["invoiceStatement"],
    translationAction: "rejectStatement",
    target: "statement",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};
